export default __webpack_public_path__ + "static/media/icon_ilustraciones.9aa3acd3.svg";